import * as Yup from 'yup';
import { calculationType } from '@modules/admin/Tools/LenderUtility/tabs/DocFees/DocFeesTable/interfaces';

export const stateProductRestrictionSchema = Yup.object().shape({
  state: Yup.string().nullable().required(),
  productType: Yup.string().nullable().required(),
  maxAllowedAmount: Yup.string().nullable().when('calculationType', {
    is: (type: number) => {
      const validateAmount = type !== calculationType.Formula && !Yup.ref('maxAllowedAmount').isValue;
      const validateFormula = type !== calculationType.FlatFee && !Yup.ref('maxAllowedFormula').isValue;
      return validateAmount || validateFormula;
    },
    then: Yup.string().nullable().required(),
    otherwise: Yup.string().nullable(),
  }),
  isAllowed: Yup.boolean()
});

export const formulaFormValidationSchema = Yup.object().shape({
  maxAllowedFormula: Yup.string().nullable().required('Formula is required'),
});